<template>
  <div class="main-editor">
    <div class="main-editor-header" v-if="showDashboard">
      <MainTopNav></MainTopNav>
    </div>
    <div class="main-editor-side" :class="{'show': isMobileSideBarShow}" v-if="showDashboard">
      <MainSideBar></MainSideBar>
    </div>
    <div class="main-editor-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainSideBar from '@/views/EditMainScreen/MainSideBar.vue';
import MainTopNav from '@/views/EditMainScreen/MainTopNav.vue';

export default {
  name: 'EditMainScreen',
  data() {
    return {
      READ_INFO_BUSY: 'READ_INFO_BUSY',

      user: {
        serial: -1,
        name: '',
      },

      currentPage: this.$currentRouteName || 'Unknown',
    };
  },
  components: {
    MainSideBar,
    MainTopNav,
  },
  computed: {
    ... mapGetters(['isMobileSideBarShow']),
    // 定義 computed 屬性，根據當前路由名稱決定是否顯示
    showDashboard() {
      const hideDashboard = Boolean(this.$route.meta.hideDashboard);
      return !hideDashboard
    },
  },
  // async mounted() {
  //   const hasToken = this.$store.getters['auth/hasToken'];
  //   if (!hasToken) {
  //     this.$router.push({
  //       name: 'Login'
  //     });
  //   }
  //   await this.readInfo();
  // },
  // mounted() {
  //   this.$router.push({ name: 'ShopIndex' });
  // },
  methods: {
    // logout() {
    //   this.$store.dispatch('auth/loggedOut');
    //   this.$router.push({
    //     name: 'Login'
    //   });
    // },
    // async readInfo() {
    //   this.$store.dispatch('appendComponentBusy', this.READ_INFO_BUSY);
    //   try {
    //     const infoRes = await this.$store.dispatch('api/getBusinessAccountInfoPromise');
    //     this.user = Object.assign({}, this.user, infoRes);
    //   } catch (error) {
    //     this.$store.dispatch('showMsg', error.toString());
    //   } finally {
    //     this.$store.dispatch('clearComponentBusy', this.READ_INFO_BUSY);
    //   }
    //
    // }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
  .main-editor {
    display: grid;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
      "header header"
      "side main";
    @include smaller-than-medium() {
      grid-template-areas:
        "header header"
        "main main";
    }
  }

  .main-editor-side {
    grid-area: side;
    @include smaller-than-medium() {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100vh;
      background-color: #fff;
      z-index: 1000;
      transform: translate(-100%, 0);
      transition: transform .2s ease;
      &.show {
        transform: translate(0, 0);
      }
    }
  }

  .main-editor-main {
    grid-area: main;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .main-editor-header {
    grid-area: header;
  }
</style>
